import styled from "styled-components";
import Colors from "../../themes/Colors";

const CampaignManagerHolder = styled.div`
  /* 120px = alto del topbar fijo */
  padding: 120px 12px 40px;

  @media only screen and (min-width: 768px) {
    padding: 120px 20px 40px;
  }

  /* < 1200px: los botones Volver/Continuar viven en una barra fija inferior,
     dejamos espacio para que no tapen el final del contenido */
  @media only screen and (max-width: 1199px) {
    padding-bottom: 96px;
  }

  /* Los Col laterales deben estirarse a la altura del contenido para que
     el sticky de los sidebars tenga recorrido */
  .campaignManagerRow.ant-row-flex-top {
    align-items: stretch;
  }

  .campaignManagerMain {
    min-width: 0;
  }

  /* Toggle "Información de campaña": solo en tablet/mobile */
  .sideInfoToggleCol {
    display: none;
  }
  @media only screen and (max-width: 1199px) {
    .sideInfoToggleCol {
      display: block;
      margin-bottom: 10px;
    }
    .sideInfoToggle {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 10px;
      min-height: 46px;
      padding: 8px 14px;
      background: ${Colors.snow};
      border: 1px solid ${Colors.border};
      border-radius: 12px;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
      color: ${Colors.primaryAccent};
      font-size: 15px;
      font-weight: 600;
      text-align: left;
      cursor: pointer;
      outline: none;
    }
    .sideInfoToggle:active {
      opacity: 0.85;
    }
    .sideInfoToggleIcon {
      font-size: 18px;
      flex: 0 0 auto;
    }
    .sideInfoToggleTitle {
      flex: 0 0 auto;
      white-space: nowrap;
    }
    .sideInfoToggleSummary {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-wrap: wrap;
      gap: 4px 14px;
      justify-content: flex-end;
      color: ${Colors.coal};
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
    }
    .sideInfoToggleSummary > span {
      white-space: nowrap;
    }
    .sideInfoToggleChevron {
      margin-left: auto;
      flex: 0 0 auto;
      font-size: 14px;
    }
    .sideInfoToggleSummary + .sideInfoToggleChevron {
      margin-left: 0;
    }
    /* Colapsado: se ocultan las cards, quedan solo los botones fijos */
    /* Colapsado: la columna queda con alto 0 y RECORTADA. Antes solo se ocultaban
       las cards por dentro: si alguna quedaba fuera de esa regla, se desbordaba del
       contenedor de alto 0 y flotaba sobre el contenido. Con overflow:hidden eso no
       puede pasar, y los botones Volver/Continuar se siguen viendo porque son
       position:fixed (el recorte no alcanza a los elementos fijos). */
    .campaignManagerRow.sideInfoCollapsed .leftSideCards,
    .campaignManagerRow.sideInfoCollapsed .rightSideCards {
      display: none;
    }
    .campaignManagerRow.sideInfoCollapsed .campaignManagerSide > div {
      padding-top: 0;
      height: 0;
      overflow: hidden;
    }
    .campaignManagerRow.sideInfoCollapsed .campaignManagerSideRight {
      margin-top: 0;
    }
  }
  /* Mobile: el resumen pasa a una segunda línea debajo del título */
  @media only screen and (max-width: 575px) {
    .sideInfoToggle {
      font-size: 14px;
      padding: 8px 12px;
      flex-wrap: wrap;
      row-gap: 4px;
    }
    .sideInfoToggleSummary {
      order: 1;
      justify-content: flex-start;
      flex-basis: 100%;
      padding-left: 28px;
    }
    .sideInfoToggleChevron,
    .sideInfoToggleSummary + .sideInfoToggleChevron {
      order: 0;
      margin-left: auto;
    }
  }

  @media only screen and (min-width: 1200px) {
    .campaignManagerSideLeft {
      padding-right: 12px;
    }
    .campaignManagerSideRight {
      padding-left: 12px;
    }
  }

  /* 768-1199px: sidebars arriba, uno al lado del otro */
  @media only screen and (min-width: 768px) and (max-width: 1199px) {
    .campaignManagerSideLeft {
      padding-right: 10px;
    }
    .campaignManagerSideRight {
      padding-left: 10px;
    }
  }

  /* 576-767px: dos columnas angostas arriba */
  @media only screen and (min-width: 576px) and (max-width: 767px) {
    .campaignManagerSideLeft {
      padding-right: 5px;
    }
    .campaignManagerSideRight {
      padding-left: 5px;
    }
  }
  /* < 576px: apilados; el segundo sidebar pega justo debajo del primero */
  @media only screen and (max-width: 575px) {
    .campaignManagerSideRight {
      margin-top: 10px;
    }
  }

  h3 {
    color: ${Colors.primaryAccent};
    font-size: 18px;
    font-weight: 600;
  }

  p {
    color: ${Colors.coal};
    font-size: 15px;
  }

  .warningCard {
    margin: 0 0 15px;
    border-radius: 10px;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
    background-color: #f74f48;
    border: 1px solid ${Colors.border};
  }
  .warningTextCard {
    color: ${Colors.white};
  }

  .campaingInfoCard {
    background-color: ${Colors.snow};
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 16px;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);

    @media only screen and (max-width: 767px) {
      padding: 14px 12px;
      margin-bottom: 14px;
    }
  }

  /* Títulos de sección de cada paso (Organizar pantallas, Ajuste de frecuencia, etc.) */
  .stepSectionTitle {
    color: ${Colors.primaryAccent};
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 12px;
    overflow-wrap: anywhere;

    @media only screen and (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  }

  .successCard {
    margin: 0 0 15px;
    border-radius: 16px;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
    @media only screen and (max-width: 768px) {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  .successTextCard {
    color: ${Colors.primaryAccent};
  }

  .formInput.ant-input::placeholder {
    color: ${Colors.textMuted};
  }

  .formInput.ant-input:hover,
  .formInput.ant-input:focus {
    border-right-width: 2px !important;
  }

  .formInput input:focus,
  .formInput input[type="text"]:focus,
  .formInput input[type="password"]:focus,
  .formInput input[type="email"]:focus,
  .formInput input[type="number"]:focus,
  .formInput textarea:focus {
    border: 2px solid #424242;
    color: ${Colors.coal};
  }

  .formInput.ant-input:focus {
    box-shadow: none;
  }

  .draggerContainer {
    margin: 0 0 15px;
  }

  .draggerContainerHelp {
    line-height: 100%;
  }

  .button {
    height: 46px;
    font-weight: 600;
    font-size: 18px;
    border-radius: 10px;
    padding: 0 25px;
  }

  .clearButton {
    margin-top: 20px;
  }
  .addGeneralRuleButton {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .canvaButton {
    margin-top: 0px;
  }
  .videoUploadEmpty {
    border: dashed;
    border-radius: 10px;
    border-left-width: 1px;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-right-width: 1px;
    border-color: ${Colors.border};
    padding-left: 10% !important;
    padding-right: 10% !important;
    min-height: 200px;
    left: 10px;
  }
  .actuallyBudget {
    margin-right: 2%;
    border: solid;
    border-radius: 10px;
    border-left-width: 1px;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-right-width: 1px;
    padding-left: 5px;
    padding-right: 5px;
    color: #1e5285;
  }
  .info-format-file {
    color: ${Colors.textMuted};
    font-size: 13px;
  }
  .textArea {
    margin-bottom: 1%;
  }
  .imprSubsidize {
    color: rgb(252, 189, 118);
    margin-left: 10px;
    font-size: 15px;
  }
  .titleField {
    margin-bottom: 5px !important;
  }
  .selectCategories {
    width: 200px;
  }
  .ant-form-item-control{
    line-height: 30px;
  }
  .selectCategoriesCampaignManager {
    width: 200px  ;
  }
  .ant-form-item-children {
    span{
      padding-left: 5px;
    }
  }
  .stepsContent {
    margin-top: 30px;
    margin-bottom: 20px;

    @media only screen and (max-width: 1199px) {
      margin-top: 10px;
    }
  }

  /* Ant reparte los pasos en anchos iguales y la línea es lo que sobra después
     del título: uno largo ("Librería de anuncios") se quedaba sin línea. Cada
     paso toma su contenido más una parte igual del espacio libre. */
  @media only screen and (min-width: 992px) {
    .stepsContent.ant-steps-horizontal .ant-steps-item:not(:last-child) {
      flex: 1 1 auto;
    }
  }

  /* Steps compactos hasta tablet (los 5 títulos no entran en una fila): se
     mantienen horizontales y solo el paso activo muestra su título (Ant los
     vuelve verticales por defecto en < 480px) */
  @media only screen and (max-width: 991px) {
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal {
      display: flex;
      align-items: flex-start;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item {
      display: flex;
      flex: 0 0 auto;
      align-items: center;
      margin-right: 8px;
      overflow: visible;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item:last-child {
      margin-right: 0;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-process {
      flex: 1 1 auto;
      min-width: 0;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-icon {
      float: none;
      margin: 0 8px 0 0;
      width: 28px;
      height: 28px;
      line-height: 28px;
      font-size: 13px;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-content {
      display: none;
      min-height: 0;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-container {
      display: flex;
      align-items: center;
      min-width: 0;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-process .ant-steps-item-content {
      display: block;
      flex: 1 1 auto;
      min-width: 0;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-title {
      font-size: 14px;
      line-height: 28px;
      padding-right: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-title::after {
      display: none;
    }
    .stepsContent.ant-steps-horizontal.ant-steps-label-horizontal > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
      display: none;
    }
  }

  .stepsContent .ant-steps-item-process .ant-steps-item-icon {
    background: ${Colors.primary} !important;
    border-color: ${Colors.primary} !important;
  }
  .stepsContent .ant-steps-item-finish .ant-steps-item-icon {
    border-color: ${Colors.primaryAccent} !important;
  }
  .stepsContent .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: ${Colors.primaryAccent} !important;
  }
  .stepsContent .ant-steps-item-wait .ant-steps-item-icon {
    border-color: ${Colors.primaryAccent} !important;
  }
  .stepsContent .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
    color: ${Colors.primaryAccent} !important;
  }
  .stepsContent .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    background-color: ${Colors.primary} !important;
  }

  /* Customize collapse element */
  .customPanelStyle {
    background: Colors.surfaceMuted !important;
    borderRadius: 4 !important;
    marginBottom: 24 !important;
    border: 0 !important;
    ${'' /* overflow: 'hidden'; */}
  };

  .ant-collapse-content {
    border-top: 0px;
  }

  .ant-collapse-header {
    color: ${Colors.primaryAccent} !important;
    font-size: 24px !important;
    padding: 20px !important;
    padding-left: 8px !important;
    padding-right: 44px !important;
    overflow-wrap: anywhere;

    @media only screen and (max-width: 767px) {
      font-size: 20px !important;
      line-height: 26px !important;
      padding: 12px 40px 12px 4px !important;
    }
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
    left: auto !important;
    right: 16px !important;
  }

  /* Customize css for collapse content*/
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 10px;
  }
  .ant-collapse-item {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 15px;
    padding-right: 15px;
    gap: 20px;
    border-radius: 8px !important;
    border: 1px !important;

    @media only screen and (max-width: 767px) {
      padding: 8px;
    }
  }
  .ant-collapse-arrow svg {
    height: 28px;
    width: 28px;
    padding: 6px 2px 6px 2px;
  }

  .contentSettingCampaign {
    display: flex;
    padding-left: 7px;
    padding-right: 5px;
  }
  .clientBrandTag {
    color: ${Colors.primaryAccent};
    height: 35px;
    padding: 15px;
    margin-right: 10px;
    display: inline;
    font-size: 12px;
    text-align: left;
    word-wrap: break-word;
  }
  .ant-collapse-extra {
    margin-right: 20px;
  }
  .clientBrandTagName {
    color: ${Colors.white};
    background: ${Colors.primary};
    width: Hug (96px);
    height: Fixed (28px);
    padding: 5px 16px 5px 16px;
    border-radius: 4px
  }

  .clientBrandTagNameText {
    color: ${Colors.textSecondary};
    margin-right: 6px;
  }

  .ant-form-item {
    margin-bottom: 0px;
  }

  .contentBrandTag {
    display: inline;
  }
  .contentMobileBrandTag {
    display: none;
  }

  /* Show brand and tag for mobile in content of panel */
  @media only screen and (max-width: 850px) {
    .ant-collapse-extra {
      display: none;
    }
    .contentMobileBrandTag {
      display: inline;
    }
    .clientBrandTag {
      padding-left: 0px;
    }
    .contentSettingCampaign {
      display: block;
    }
  }

  /* Setting brand and tag for responive */
  @media only screen and (max-width: 768px) {
    .clientBrandTagNameText, .clientBrandTagName {
      font-size: 10px;
    }
  }
  /* Setting brand and tag for responive */
  @media only screen and (max-width: 546px) {
    .ant-collapse-extra {
      margin-top: 15px;
      margin-bottom: 15px;
    }
    .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-extra {
      float: left;
    }
    .clientBrandTagNameText, .clientBrandTagName {
      font-size: 9px;
    }
  }

  /* Setting brand and tag for responive */
  @media only screen and (max-width: 470px) {
    .contentBrandTag {
      display: grid;
    }
    .ant-collapse-extra {
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .clientBrandTagNameText, .clientBrandTagName {
      font-size: 10px;
    }
  }
  .continueButtons {
    position: static;
    width: 100%;
    z-index: 996;
    height: 45px;
    line-height: 30px;
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
    font-size: 18px;
    text-align: center;
    color: aliceblue;
    border-radius: 8px;
    margin: 0;
    padding: 0 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .continueButtonsEditCreate {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
  }
  .continueButtonsEditCreate i {
    margin-left: 0px !important;
    padding-left: 10px;
  }
  .goBackButtons {
    position: static;
    margin: 0;
    width: 100%;
    z-index: 996;
    height: 45px;
    line-height: 30px;
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
    font-size: 18px;
    text-align: center;
    color: aliceblue;
    border-radius: 8px;
    padding: 0 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .continueButtons[disabled],
  .goBackButtons[disabled] {
    opacity: 0.6;
    color: ${Colors.onPrimary};
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
  }
  .guideButton {
      margin: 0;
      border: 0px;
      background: ${Colors.primary};
      color: ${Colors.onPrimary};
      font-weight: bold;
      border-radius: 8px;
      text-align: center;
      width: 100%;
      height: 40px;
  }

  /* < 1200px: barra de acciones fija abajo con Volver / Continuar */
  @media only screen and (max-width: 1199px) {
    &::after {
      content: '';
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 68px;
      background: ${Colors.snow};
      opacity: 0.94;
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);
      border-top: 1px solid ${Colors.border};
      z-index: 996;
      pointer-events: none;
    }
    .goBackButtons,
    .continueButtons {
      position: fixed;
      bottom: 12px;
      z-index: 997;
      width: calc(50% - 18px);
      max-width: 320px;
      height: 44px;
      font-size: 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
    .goBackButtons {
      left: 12px;
    }
    .continueButtons {
      right: 12px;
    }
  }
  .customPanelStyleDisplays {
    border: 1px solid ${Colors.border};
    padding-right: 10px;
    padding-left: 10px;
    border-radius: 16px;
    box-shadow: 0px 4px 6px 2px #0000001A;
  }
  .stepTwoTop {
    padding-bottom: 20px;
  }
  .stepTwoTopRow.ant-row-flex-top {
    align-items: stretch;
  }
  /* Más específico que .contentFilter (margin-top 10px) para que la card
     de altura 100% no se salga del Col y pise el panel de abajo */
  .stepTwoTopRow .stepTwoCard {
    height: 100%;
    margin: 0;
    min-width: 0;
  }
  .ScreensGroupFilterContainer {
    margin-right: 10px;
  }
  .contentFilter {
    font-size: 15px;
    margin-bottom: 15px;
    margin-top: 10px;
    padding-left: 8px;
  }
  .groupFilter {
    gap:10px;
  }
  .groupFilter .ant-btn {
    border-radius: 8px;
  }
  /* Botón final (Crear campaña / Guardar y pagar): texto largo, se permite
     que envuelva en la columna angosta del sidebar en lugar de cortarse */
  .continueButtons.createButton {
    padding: 4px 8px;
    font-size: 14px;
    line-height: 18px;
    height: auto;
    min-height: 45px;
    white-space: normal;
  }
  .createButton .createIcon {
    margin-left: 6px;
  }
`;

export default CampaignManagerHolder;